/* eslint-disable @typescript-eslint/no-explicit-any */
import DOMPurify from 'isomorphic-dompurify';

export const OffersCountdownEyebrowBannerConfig = {
  emptyLabel: 'OCountdownEyebrowBanner',
  isEmpty: () => false,
  resourceType: 'mi-aem-utils/components/content/cobrand/o-countdown-eyebrow-banner',
};

export const DAY_MS = 24 * 60 * 60 * 1000;

export const getAccessibleTimerAnnouncement = (targetDate?: string): string => {
  if (!targetDate) {
    return '';
  }

  const target = new Date(targetDate).getTime();

  if (Number.isNaN(target)) {
    return '';
  }

  const difference = target - Date.now();

  if (difference <= 0) {
    return '0 days, 0 hours, 0 minutes remaining';
  }

  const days = Math.floor(difference / DAY_MS);
  const hours = Math.floor((difference % DAY_MS) / (1000 * 60 * 60));
  const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));

  return `${days} days, ${hours} hours, ${minutes} minutes remaining`;
};

export const getAccessiblePromoText = (html?: string): string => {
  if (!html) {
    return '';
  }

  const cleanEl = DOMPurify.sanitize(html, {
    RETURN_DOM: true,
  }) as unknown as HTMLElement;

  const deletedElements = cleanEl.querySelectorAll('del, strike, s');
  deletedElements.forEach(element => element.remove());

  return (cleanEl.textContent || '').trim().replace(/\s+/g, ' ');
};

export function getBannerVisibility(
  enableCountdownTimerBanner: any,
  bookingEndDate: string | number | Date,
  showWindowDays: number,
  now = Date.now()
) {
  if (!enableCountdownTimerBanner || !bookingEndDate || showWindowDays < 0) return false;
  const expirationTs = new Date(bookingEndDate).getTime();
  if (Number.isNaN(expirationTs)) return false;
  const remainingMs = expirationTs - now;
  if (remainingMs <= 0) return false;
  const remainingDays = Math.ceil(remainingMs / DAY_MS);
  return remainingDays <= showWindowDays;
}

export const toLocalEndOfDayISOString = (dateString: string): string => {
  const [year, month, day] = dateString.split('-').map(Number);

  const date = new Date(year, month - 1, day, 23, 59, 59, 999);

  const offsetMinutes = -date.getTimezoneOffset();
  const sign = offsetMinutes >= 0 ? '+' : '-';

  const hours = String(Math.floor(Math.abs(offsetMinutes) / 60)).padStart(2, '0');
  const minutes = String(Math.abs(offsetMinutes) % 60).padStart(2, '0');

  return `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(
    2,
    '0'
  )}T23:59:59.999${sign}${hours}:${minutes}`;
};

export const isTargetDateExpired = (targetDate?: string): boolean => {
  if (!targetDate) {
    return false;
  }

  const target = new Date(targetDate).getTime();

  if (Number.isNaN(target)) {
    return false;
  }

  return target - Date.now() <= 0;
};
